import { Helmet } from 'react-helmet-async';
import { Meta } from './seo/Meta';
import { Hero } from './sections/Hero';
import { PainPoints } from './sections/PainPoints';
import { Formats } from './sections/Formats';
import { Method } from './sections/Method';
import { HowItWorks } from './sections/HowItWorks';
import { Cases } from './sections/Cases';
import { CtaStrip } from './sections/CtaStrip';
import { About } from './sections/About';
import { Faq } from './sections/Faq';
import { ContactForm } from './sections/ContactForm';
import { LandingHeader } from './components/LandingHeader';
import { CookieNotice } from './components/CookieNotice';
import { FloatingDock } from './components/FloatingDock';
import { Reveal } from './components/Reveal';

export function LandingPage() {
  return (
    <div id="top" className="landing-root scroll-smooth min-h-screen bg-l-paper text-l-ink font-sans overflow-x-hidden">
      <Meta
        title="Мария Брызгалова — репетитор по математике · ОГЭ и ЕГЭ"
        description="17 лет опыта. Готовлю к ОГЭ и ЕГЭ, подтягиваю с нуля. Программа под ученика, онлайн-занятия. Первое занятие — пробное."
        canonical="https://matemasha.ru/"
        ogImage="https://matemasha.ru/landing/og.png"
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Person',
            name: 'Мария Брызгалова',
            jobTitle: 'Репетитор по математике',
            url: 'https://matemasha.ru/',
            image: 'https://matemasha.ru/landing/maria.jpg',
            worksFor: { '@type': 'Organization', name: 'matemasha.ru' },
            areaServed: { '@type': 'City', name: 'Екатеринбург' },
            makesOffer: {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Service',
                name: 'Индивидуальные занятия по математике',
                description: 'Подготовка к ОГЭ и ЕГЭ, подтягивание школьной программы',
              },
            },
          })}
        </script>
      </Helmet>
      <LandingHeader />
      <main>
        <Reveal><Hero /></Reveal>
        <Reveal><PainPoints /></Reveal>
        <Reveal><Formats /></Reveal>
        <Reveal><Method /></Reveal>
        <Reveal><HowItWorks /></Reveal>
        <Reveal><Cases /></Reveal>
        <Reveal><CtaStrip /></Reveal>
        <Reveal><About /></Reveal>
        <Reveal><Faq /></Reveal>
        <Reveal><ContactForm /></Reveal>
      </main>
      <footer className="bg-l-paper px-6 md:px-10 py-10 border-t border-l-rule">
        <div className="mx-auto max-w-[1120px] flex flex-col sm:flex-row justify-between gap-4 font-sans text-l-ink-muted text-sm">
          <span>© {new Date().getFullYear()} Мария Брызгалова · matemasha.ru</span>
          <a href="/privacy" className="hover:text-l-terracotta">
            Политика обработки данных
          </a>
        </div>
      </footer>
      <FloatingDock />
      <CookieNotice />
    </div>
  );
}
